export default __webpack_public_path__ + "locales/ar-SA/FilesSettings.json?hash=0cb1ad00be8333f09f3cce18c1810554";